import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import AsyncSelect from 'react-select/async';

const DefaultSelect = (props) => {
  const customProps = () => {
    let customProps = {};
    if (props['data-testid']) {
      customProps['data-testid'] = props['data-testid'];
    }

    return customProps;
  };

  return (
    <AsyncSelect
      placeholder='Teste se funciona'
      isDisabled={props.disabled}
      isClearable={props.isClearable}
      cacheOptions
      loadOptions={props.loadOptions}
      defaultOptions={props.defaultOptions ? props.defaultOptions : []}
      onChange={(selected) => props.onChange(props.inputName, selected)}
      value={props.selected}
      {...customProps()}
    />
  );
};

const CustomAsyncSelect = (props) => {
  return (
    <FormGroup>
      <Label for={props.inputName}>{props.labelText}</Label>
      <DefaultSelect {...props} />
    </FormGroup>
  );
};

CustomAsyncSelect.defaultProps = {
  disabled: false,
  cacheOptions: '',
  isClearable: true,
  selected: null,
  placeholder: 'Digite ou selecione...'
};

CustomAsyncSelect.propTypes = {
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  defaultOptions: PropTypes.array,
  validation: PropTypes.array
};

export default CustomAsyncSelect;
